module.exports = __webpack_public_path__ + "static/media/join-affiliate-programs.f872f066.png";